
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cart49ktQJeNt_45nuXcLfTg0wibIlYyikUNFgmnb4bduCS9oMeta } from "/opt/buildhome/repo/pages/cart.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta } from "/opt/buildhome/repo/pages/login.vue?macro=true";
import { default as pressJJVJI3gvn6q5RLmovrGoCoXzMLygrNPiVHDMLnTNY10Meta } from "/opt/buildhome/repo/pages/press.vue?macro=true";
import { default as searchVZHeG3_X8t_IjAUUzx95piBYJ_XkAO6zB8qw3F4DYRcMeta } from "/opt/buildhome/repo/pages/search.vue?macro=true";
import { default as isrtestMMgmYxSifyL1gB3QfEe6ZTcmpRQo78u7xB6_2FXgV7oMeta } from "/opt/buildhome/repo/pages/isrtest.vue?macro=true";
import { default as sitemapRAisXoZK5HnX9gP4GeOCNyiX2jhMw_43c23RS0_z7RoMeta } from "/opt/buildhome/repo/pages/sitemap.vue?macro=true";
import { default as about_45us_uxBuLYkM00cimo29xT3q99ktCMQX7EN_o7e5usDikwMeta } from "/opt/buildhome/repo/pages/about-us.vue?macro=true";
import { default as registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta } from "/opt/buildhome/repo/pages/register.vue?macro=true";
import { default as franchise5OqXjhO23rpOGtCZp1_455p9GNFolWlwLV7Y2IA3WwNIgMeta } from "/opt/buildhome/repo/pages/franchise.vue?macro=true";
import { default as our_45storyf9PD4CN6fDv9jD_zOxPOHsc1fkEFRCq3oOphsA968fUMeta } from "/opt/buildhome/repo/pages/our-story.vue?macro=true";
import { default as affiliatesLrTxRQFW6z6okdmdrgqUZOSzbUqTJZCcjCn8f8xi9LQMeta } from "/opt/buildhome/repo/pages/affiliates.vue?macro=true";
import { default as contact_45usL5sA0Zp5dgV4Bd8KjQI9Pm2HbGOBREFE542cDiDC_P8Meta } from "/opt/buildhome/repo/pages/contact-us.vue?macro=true";
import { default as _91slug_93TVXfQgR7E_1etoF9MB3cfpp6TKNvvtjRnrJxWZr59DgMeta } from "/opt/buildhome/repo/pages/blog/[slug].vue?macro=true";
import { default as _4_45cs_45diamondcVO1wIhxonIsVDTgs0edR_45h6kr_JM4XDrM4lZxWnHbgMeta } from "/opt/buildhome/repo/pages/4-cs-diamond.vue?macro=true";
import { default as free_45productnzl7kyVNtwPAlAbZM6FJyeqRZjLzuDw0opez6TgSmKUMeta } from "/opt/buildhome/repo/pages/free-product.vue?macro=true";
import { default as lab_45diamondsSxCMf3GR44GkJBhF_45dcIDKlZvH9LMohBcxTJySwHuI8Meta } from "/opt/buildhome/repo/pages/lab-diamonds.vue?macro=true";
import { default as share_45moment1jnKYCX4xwNejRyFQnIKIx_lAUFcYgPtipA5KOfXk7gMeta } from "/opt/buildhome/repo/pages/share-moment.vue?macro=true";
import { default as _91slug_93g7jc7sy03BcfUACnh4nHxOLHjzOIERBYrFLFeo5b5tQMeta } from "/opt/buildhome/repo/pages/[type]/[slug].vue?macro=true";
import { default as cookie_45policyMIFETaySFO4h2vvjlHBOZNyTe_k1Vy9bHWMdPvEBTrUMeta } from "/opt/buildhome/repo/pages/cookie-policy.vue?macro=true";
import { default as detailZG8uqKRMEcPbyrtp74cFPEYxPDJ_45ztxQ0mSNFpzB_gEMeta } from "/opt/buildhome/repo/pages/account/detail.vue?macro=true";
import { default as privacy_45policyek63hKQ8ZMx2nIQV88L2_dad1Zv4m5Ym_n4RQ7NuSXAMeta } from "/opt/buildhome/repo/pages/privacy-policy.vue?macro=true";
import { default as reset_45password7TTpC6bsKAnTRrn0c2lyZltThWIyP9fDCYnH6eGiD0oMeta } from "/opt/buildhome/repo/pages/reset-password.vue?macro=true";
import { default as forgot_45passwordePKZgRXq0jrO1cJ61G6O25BiZx2cM1j2xdPJj4IzVnsMeta } from "/opt/buildhome/repo/pages/forgot-password.vue?macro=true";
import { default as completeAYy90s8JXD0E1RYB9Z4RvyuDS0VCL_zy1fKk_YIbVFAMeta } from "/opt/buildhome/repo/pages/pendant/complete.vue?macro=true";
import { default as terms_45of_45serviceW1t_45jMqJI4Xxtn_45N8YS_45DQhUyytODfRcGH7elbilobAMeta } from "/opt/buildhome/repo/pages/terms-of-service.vue?macro=true";
import { default as index9FQLTbkoQ0lmA9b_45I3tN9YlgqH_45y0l74RrPeLkUMb00Meta } from "/opt/buildhome/repo/pages/appointment/index.vue?macro=true";
import { default as completehEXMcwnoSuhODcV8KyYlPazMVsjZsh_9DSv8RLNaicYMeta } from "/opt/buildhome/repo/pages/earrings/complete.vue?macro=true";
import { default as our_45share_45of_45carehHB_f8HWRPcn46zx7IBT408tK38glEBY7sqQvuhn0h4Meta } from "/opt/buildhome/repo/pages/our-share-of-care.vue?macro=true";
import { default as thank_45youh_qeQxAm7kNzxCz2YNZNzaV_450Gu3V1wh_eR4mxfDNbgMeta } from "/opt/buildhome/repo/pages/checkout/thank-you.vue?macro=true";
import { default as customized_45jewelryBlo_aUx_45QyOmROG9VvsSvQKcH3tyLLrGhpEdUFxpmKcMeta } from "/opt/buildhome/repo/pages/customized-jewelry.vue?macro=true";
import { default as indexuoyqJiTG7avJdrw5r5TWQakPg8GPuLm_45_vSDO_45WerdkMeta } from "/opt/buildhome/repo/pages/fine-jewelry/index.vue?macro=true";
import { default as indexvssrStqlunzQQexXqSVGueIAAX_aH4kyt9f6VjR2tkQMeta } from "/opt/buildhome/repo/pages/high-jewelry/index.vue?macro=true";
import { default as indexfhwMjPZUuHyhEz5TtJwJImBg83GpHipyrxzYQTG4opgMeta } from "/opt/buildhome/repo/pages/jewelry-sale/index.vue?macro=true";
import { default as ringsUozITWYj4aa3p3jwbvVTLPD92Q_aHBDeyxR4QbZlG6gMeta } from "/opt/buildhome/repo/pages/jewelry-sale/rings.vue?macro=true";
import { default as indexPZLgVF0uYnWa6v5AuJ4_n5U00l_1JjT8ka330eDn_hwMeta } from "/opt/buildhome/repo/pages/testimonials/index.vue?macro=true";
import { default as _91id_93b4lY61wj16a8K6kyDbqGLE5Uel1xKulx2JH_jP4_ZtcMeta } from "/opt/buildhome/repo/pages/account/orders/[id].vue?macro=true";
import { default as indexqmAJvtNHDMZqiDCOcZ_45PyzrUXjhb7E8mDQurGys7ziIMeta } from "/opt/buildhome/repo/pages/wedding-rings/index.vue?macro=true";
import { default as indexZbLlXqe_45wEtVUmy6VGSnLOfOi62mTrWOclwgnuDcPmoMeta } from "/opt/buildhome/repo/pages/account/orders/index.vue?macro=true";
import { default as servicesSizep8gtV2yCPRQdX7b3gSL3qlOYXy2HgHbRvYQwXecMeta } from "/opt/buildhome/repo/pages/appointment/services.vue?macro=true";
import { default as thankyounCYvXgI8PBoeJZ4gkdiimlcCBS5sLrLGm8TOR02RaW8Meta } from "/opt/buildhome/repo/pages/appointment/thankyou.vue?macro=true";
import { default as faqbp7fTPOakqAWJ5gVfpzD_58l_aHj04_45A_45eHTCbFkaNkMeta } from "/opt/buildhome/repo/pages/customer-service/faq.vue?macro=true";
import { default as allxt_0O3mprSnO2Pd5bNt7qOrPFP_45yXbsdzb2IAtA9RecMeta } from "/opt/buildhome/repo/pages/engagement-rings/all.vue?macro=true";
import { default as know_45moreN9j10ZhzYlff4Un7FbpE2snRN1v3w5SmpozmH283HEcMeta } from "/opt/buildhome/repo/pages/appointment/know-more.vue?macro=true";
import { default as how_45to_45find_45ring_45sizeqsfdKaPloUFpdNv7R5xiyqfatGvIYdlN4xlW7Y_ZujkMeta } from "/opt/buildhome/repo/pages/how-to-find-ring-size.vue?macro=true";
import { default as earrings1ZaumQUVxuRMXiVEEbKnavfNvv0Jrleafy8aK7spxVoMeta } from "/opt/buildhome/repo/pages/jewelry-sale/earrings.vue?macro=true";
import { default as indexAREtN02BzTgjTZWylqv57NxnA7mg_458h8mJvXZqiMsZYMeta } from "/opt/buildhome/repo/pages/preset-earrings/index.vue?macro=true";
import { default as index5MTwZvqSoWIZTV2mVp2oz9EOaGTlO4rpbe3wFjwjscUMeta } from "/opt/buildhome/repo/pages/preset-pendants/index.vue?macro=true";
import { default as rare_45style_45real_45carat12bnudzGJz1StjEIxKO_GYQpAiGQDagekdZY5nIH5ZsMeta } from "/opt/buildhome/repo/pages/rare-style-real-carat.vue?macro=true";
import { default as zales_45it_45with_45jewelryM_45Z3kMELOcBgZ4NeIvbgKNv645LnDG4JlVvPFVBDHeAMeta } from "/opt/buildhome/repo/pages/zales-it-with-jewelry.vue?macro=true";
import { default as index0h9nW_TJMCs47_JJvuuwBhQG7oCOm_45xZtZVJKJJvE80Meta } from "/opt/buildhome/repo/pages/customer-service/index.vue?macro=true";
import { default as indexCSQ1pwV5nH1516HVJjXuonvfW5Nbr9z9g8vLkp_45cStcMeta } from "/opt/buildhome/repo/pages/engagement-rings/index.vue?macro=true";
import { default as braceletskEUB175santCJ5gXQqYOBqn_45tBQdN7IGsOyIXGkYaIEMeta } from "/opt/buildhome/repo/pages/jewelry-sale/bracelets.vue?macro=true";
import { default as necklacesSrhMadWhaFzzsJu9RxTKRsnxlpaCA1_gTHj_jVBmt0kMeta } from "/opt/buildhome/repo/pages/jewelry-sale/necklaces.vue?macro=true";
import { default as ready_45to_45ship_45earringsN6_45lWakDU__45lfq0H2hKWIY5BhbE23y47bKMI5WgdmX0Meta } from "/opt/buildhome/repo/pages/ready-to-ship-earrings.vue?macro=true";
import { default as ready_45to_45ship_45pendantsXFynAAPDii02gpb21q2pygrEKbQvCCFXM_45De1y4eO5gMeta } from "/opt/buildhome/repo/pages/ready-to-ship-pendants.vue?macro=true";
import { default as valentines_45day_45jewelryGkaJvDS5VEAVpVI_MNKISYg45PB_hVG__b67DevWBzIMeta } from "/opt/buildhome/repo/pages/valentines-day-jewelry.vue?macro=true";
import { default as change_45password5c8UtNL2f4_8kDI_45EFEnOGAqiMZ_kDPpCs2RNmYtUb8Meta } from "/opt/buildhome/repo/pages/account/change-password.vue?macro=true";
import { default as hues_45ringst93q6GLqd2vHGdX7HSSur4TeKim4mGoYPQGg3mc1SdgMeta } from "/opt/buildhome/repo/pages/high-jewelry/hues-rings.vue?macro=true";
import { default as blue_45vs_45nile_45ring_45stylesMMLE_45XJTtBNvQW6QhTIDGcdCmL5rgQtsnyRINo0uK5oMeta } from "/opt/buildhome/repo/pages/blue-vs-nile-ring-styles.vue?macro=true";
import { default as _91identifier_93zjXnlVrgeDAAU_45zA4Gyh_451Jk5vBOipq2aiMpC7PcWRwMeta } from "/opt/buildhome/repo/pages/checkout/sp/[identifier].vue?macro=true";
import { default as completelvF_Voc9uNnjZvlaeJ7_45bqVEO70wnBiQCLCuWDlanxAMeta } from "/opt/buildhome/repo/pages/engagement-ring/complete.vue?macro=true";
import { default as indexST7oesc4C3Ndk5vOHvvntJ_AHKVa06P90c6w1wQQqQMMeta } from "/opt/buildhome/repo/pages/inspiration-[slug]/index.vue?macro=true";
import { default as jewelry_45more_45than_45ok_45kay91f8N38z4U_N7KEmjjBWiB60NLbtyrOcVhjG7cTQ2SgMeta } from "/opt/buildhome/repo/pages/jewelry-more-than-ok-kay.vue?macro=true";
import { default as light_45performance_45reporttuTE_pCA0Zg5OYIu4elcKTi48jay4FuWLrFzSBcxWtsMeta } from "/opt/buildhome/repo/pages/light-performance-report.vue?macro=true";
import { default as _91id_93T_LO2kq_SotpKsf3eqiFNIEkHsKG1ckBxP7Gq7GcrloMeta } from "/opt/buildhome/repo/pages/account/appointments/[id].vue?macro=true";
import { default as engagement_45ring_45for_45womenF41L6BQOmKH13oiicEzbq264Ds2KgJDfRF4kohn4zigMeta } from "/opt/buildhome/repo/pages/engagement-ring-for-women.vue?macro=true";
import { default as indextmLfenBvaJrEp9UYKp0oanVE9hqxnxD1L6pI6zejYTUMeta } from "/opt/buildhome/repo/pages/testimonials/[slug]/index.vue?macro=true";
import { default as index5vzPzug0_45nppxyo2ALuqJT9IFywrJ9Wd_Y1t3V1fTMgMeta } from "/opt/buildhome/repo/pages/account/appointments/index.vue?macro=true";
import { default as _91_91sub_type_93_93jWZv2Tf6ZViVEyFFuRuF1H6I_jBLca9WuBY_45P6dwyDwMeta } from "/opt/buildhome/repo/pages/blog/[[type]]/[[sub_type]].vue?macro=true";
import { default as hoop_45earringsay1QreO04J_Oetvto7fP_ahuruaGe5VgIEumX3ULxVsMeta } from "/opt/buildhome/repo/pages/fine-jewelry/hoop-earrings.vue?macro=true";
import { default as stud_45earringsGv8Z60Vc1j7mI0E9gb5vcDCFbgn7dnUzYUHsRkOwjcUMeta } from "/opt/buildhome/repo/pages/fine-jewelry/stud-earrings.vue?macro=true";
import { default as green_45and_45sustainable_45giftMR_ku4xgdlx2_45MrSrwTXTGJn2miLifMfRAR6Fr5ITIUMeta } from "/opt/buildhome/repo/pages/green-and-sustainable-gift.vue?macro=true";
import { default as indexs33_Kr3tRW7sitJh_45uZgY6XgAJkoWf97xNoRsZsnRJgMeta } from "/opt/buildhome/repo/pages/ring-settings/[slug]/index.vue?macro=true";
import { default as couple_45ringsZUAWlM5P4X9YDSk_45BJsIMNa7f17h4_454uyGcPd0iTbpMMeta } from "/opt/buildhome/repo/pages/wedding-rings/couple-rings.vue?macro=true";
import { default as indexQeg9qZG2iJuKR_t_45C_453ytxeEBT26jS0pfT35iyOgNfsMeta } from "/opt/buildhome/repo/pages/engagement-ring-guide/index.vue?macro=true";
import { default as friendly_45diamond_45differenceifrvpiHILam1Wu4OPQ8_YiEGXBV1xsRioXVA1_4550TRIMeta } from "/opt/buildhome/repo/pages/friendly-diamond-difference.vue?macro=true";
import { default as index78t2QXkBt5jJ7yEtneefqPF2SQrKIicfGqOKVGUODG4Meta } from "/opt/buildhome/repo/pages/loose-diamonds/[slug]/index.vue?macro=true";
import { default as toi_45et_45moi_45engagement_45ringsD_TP4uY97fCG9z74GuYDVpUU1WEqvNAJXCAElh6_2_45YMeta } from "/opt/buildhome/repo/pages/toi-et-moi-engagement-rings.vue?macro=true";
import { default as indexukLSQLMXpugCm_4SxXpqp0gI7IBkUUAphWMToAuAW3cMeta } from "/opt/buildhome/repo/pages/preset-earrings/[slug]/index.vue?macro=true";
import { default as indexHX_450XKDLnc28CXx4J1yr39oAV_45bPv0sLNzNeaK4FU_sMeta } from "/opt/buildhome/repo/pages/preset-pendants/[slug]/index.vue?macro=true";
import { default as _91_91start_with_93_93auYXyTpJEbhdvzVqhrInWLs5Yw35tGyJSo84dq08Dl8Meta } from "/opt/buildhome/repo/pages/ring-settings/[[start_with]].vue?macro=true";
import { default as eternity_45ringscCHk2HBgGKUAFUb_45h7WhXdtfE_451XbFbFvTZbs3jvFLkMeta } from "/opt/buildhome/repo/pages/wedding-rings/eternity-rings.vue?macro=true";
import { default as indexi_45fm653dEwFGNM8YGx2es67xWs0PbTpTkU7OpONgvbwMeta } from "/opt/buildhome/repo/pages/[slug]-engagement-rings/index.vue?macro=true";
import { default as brilliance_45in_45lab_45grown_45ringskTuN2rTHBgO84pMhnr4unm70qBkCcAeoxCx7_457YiHq0Meta } from "/opt/buildhome/repo/pages/brilliance-in-lab-grown-rings.vue?macro=true";
import { default as indexrjYkHnWmLDSySgEaeobE86gV9Gl6_DABINwWs2d_BdMMeta } from "/opt/buildhome/repo/pages/earring-settings/[slug]/index.vue?macro=true";
import { default as bangle_45bracelets1D0W5nRIBpMaD9ttVGg8Y9m0Lz320jx3TENnD8O_45tDMMeta } from "/opt/buildhome/repo/pages/fine-jewelry/bangle-bracelets.vue?macro=true";
import { default as fashion_45earringsajH7Bcv99KEZ0RM7_Lm3VjXkm6QMzvHWkBVImnh8ZDUMeta } from "/opt/buildhome/repo/pages/fine-jewelry/fashion-earrings.vue?macro=true";
import { default as tennis_45braceletsMzEE2E_RwsgjojzGrHU7YXWCS2_XOSXwDqJ8LB19cEwMeta } from "/opt/buildhome/repo/pages/fine-jewelry/tennis-bracelets.vue?macro=true";
import { default as tennis_45necklaces5rKcBKocWAG0FFaiyUgDHIeKVE2sEGK3eiWH6PMRNr4Meta } from "/opt/buildhome/repo/pages/fine-jewelry/tennis-necklaces.vue?macro=true";
import { default as _91_91start_with_93_93SxhIi6C3xLTQGVeulfwHT7alIweAoK1fnlJox54Xj34Meta } from "/opt/buildhome/repo/pages/loose-diamonds/[[start_with]].vue?macro=true";
import { default as index_xQy4JWk8i6GP8uWSBkvLxJxPYUKWmZU1V60ZtHdqjMMeta } from "/opt/buildhome/repo/pages/pendant-settings/[slug]/index.vue?macro=true";
import { default as indexh_45YIJ4OUNSUrjlyngVBhl9UDBluZGohax_45TqGK8joiQMeta } from "/opt/buildhome/repo/pages/preset-engagement-rings/index.vue?macro=true";
import { default as return_45policydWZC_45X5TC_ghz9ntnmdQu7BHkpLm5IgjPCScqfjawPgMeta } from "/opt/buildhome/repo/pages/customer-service/return-policy.vue?macro=true";
import { default as ring_45resizingLpS3oJoTmWse1nTcYcWjk__HrzkdE9JkBav9xaxlzJMMeta } from "/opt/buildhome/repo/pages/customer-service/ring-resizing.vue?macro=true";
import { default as _91_91start_with_93_93tF_45VZc7vRIm0FHckrKofUDf2HZgyJb3Bbii9sRQcQIkMeta } from "/opt/buildhome/repo/pages/diamond-jewelry/[[start_with]].vue?macro=true";
import { default as fashion_45bracelets_f6QLeuW1fGGorBPTqcOJmCigRUy1rjwr07LzJIGX4sMeta } from "/opt/buildhome/repo/pages/fine-jewelry/fashion-bracelets.vue?macro=true";
import { default as fashion_45necklacesKkco2lYmQzNbJ6TKzH4w__Ksc7RdJKp0AeRjc502Cy0Meta } from "/opt/buildhome/repo/pages/fine-jewelry/fashion-necklaces.vue?macro=true";
import { default as initial_45necklaces9kL4y_45pVAdDS2MHczpAij5vrrX9TLMMYqvpjDNR7ay0Meta } from "/opt/buildhome/repo/pages/fine-jewelry/initial-necklaces.vue?macro=true";
import { default as ready_45to_45ship_45engagement_45rings2bKy5NJxdkTKEjE4Os4N2juUn5Rg15dTs_Qp_XOmDxsMeta } from "/opt/buildhome/repo/pages/ready-to-ship-engagement-rings.vue?macro=true";
import { default as ring_45engravingL0BSkgX8HfUdHnHgn_n8UGoxioBvKFbcZW0y0D5lq3sMeta } from "/opt/buildhome/repo/pages/customer-service/ring-engraving.vue?macro=true";
import { default as _91_91start_with_93_93W8cHSCUiWdbJuEKS8LP9ZMU2bQQsMHbQYw4yWgDaeqsMeta } from "/opt/buildhome/repo/pages/earring-settings/[[start_with]].vue?macro=true";
import { default as ring_45costIwIyXEEETPMNy3383nB_45l9QuD31dydfOQoCcLUvEvHMMeta } from "/opt/buildhome/repo/pages/engagement-ring-guide/ring-cost.vue?macro=true";
import { default as _91_91start_with_93_93YqEARdqPiJsciL9dNFnmzg_45Hy2JlLhitO1BOnFgKWAoMeta } from "/opt/buildhome/repo/pages/pendant-settings/[[start_with]].vue?macro=true";
import { default as anniversary_45ringsAUNcf4MtM3eEbr9kfw7taMYN3hTQ8H3pMU0GgzTH3iQMeta } from "/opt/buildhome/repo/pages/wedding-rings/anniversary-rings.vue?macro=true";
import { default as indexSIIrqcns3yQldrdyt0i0Gyp8L87fdxKknkg7HpJnrXEMeta } from "/opt/buildhome/repo/pages/[slug]-carat-diamond-rings/index.vue?macro=true";
import { default as exchange_45policyEy9GyKXpSsuJiitKShOgDs1wYJ14R1Hura6Y6w_zMWIMeta } from "/opt/buildhome/repo/pages/customer-service/exchange-policy.vue?macro=true";
import { default as payment_45options5WCfmcJnaV7KeMHz0Dlij9fzLNgeVZ39uv0IPMXnfHwMeta } from "/opt/buildhome/repo/pages/customer-service/payment-options.vue?macro=true";
import { default as shipping_45policyr_45opjC3YcaiqpdpH8nTZ7z_45rtBAlVjE4MkZBYuL8kmcMeta } from "/opt/buildhome/repo/pages/customer-service/shipping-policy.vue?macro=true";
import { default as solitaire_45necklacesNH0JvWLRwgx143X5V0cyamVRct8GVa_45RunE4ZpSu25YMeta } from "/opt/buildhome/repo/pages/fine-jewelry/solitaire-necklaces.vue?macro=true";
import { default as brilliant_45and_45earth_45friendly_45rings4URHaibDZ7pF2GDTj7B3SgmTegEN_jUC5t6Xko7bmjcMeta } from "/opt/buildhome/repo/pages/brilliant-and-earth-friendly-rings.vue?macro=true";
import { default as ethical_45and_45conflict_45free_45diamondsbjjhwHloB7Z7Nzitm_450vQ4Rv46uu5HHkM8Zbd6_45_jXcMeta } from "/opt/buildhome/repo/pages/ethical-and-conflict-free-diamonds.vue?macro=true";
import { default as colored_45diamond_45ringscBEBxrWKTK99IAV3wa1kag1uGElng6Wps8qkXd8N8cAMeta } from "/opt/buildhome/repo/pages/high-jewelry/colored-diamond-rings.vue?macro=true";
import { default as rose_45portrait_45jewelryycxu4zTR4Je7pOT3GT55ToreqqVp7Znbuz_hwHua_ZcMeta } from "/opt/buildhome/repo/pages/high-jewelry/rose-portrait-jewelry.vue?macro=true";
import { default as james_45and_45allen_45found_45perfect_45ringDYhj9cXJ_456_45o66FHed0N51_U_45ThfxBi4vNMiG3wwNqgMeta } from "/opt/buildhome/repo/pages/james-and-allen-found-perfect-ring.vue?macro=true";
import { default as womens_45wedding_45rings3cR3C_GLQfntQ7Z0zvvbCbnb1a4P5nFVVOuWZ5aWU8IMeta } from "/opt/buildhome/repo/pages/wedding-rings/womens-wedding-rings.vue?macro=true";
import { default as life_45time_45warrantyWNnYePk91OQgIFyPxynoHBb3sT_34KiFN93gi6MnfEsMeta } from "/opt/buildhome/repo/pages/customer-service/life-time-warranty.vue?macro=true";
import { default as soiree_45cocktail_45jewelryO_L4v1FGuxNYuEm2JPrVZW33PsiLy5BwMnnYGoqhIx8Meta } from "/opt/buildhome/repo/pages/high-jewelry/soiree-cocktail-jewelry.vue?macro=true";
import { default as indexcIjYRUT7RcamWsEnao_XF0IwwGEHdcgQ0crd3el_458tIMeta } from "/opt/buildhome/repo/pages/preset-engagement-rings/[slug]/index.vue?macro=true";
import { default as proposal_45solutions_45by_45shane_45co_45o_45perD3SGecufPur4uvsm8tdAheTYces4cbRNB7ROGOFFJugMeta } from "/opt/buildhome/repo/pages/proposal-solutions-by-shane-co-o-per.vue?macro=true";
import { default as time_45to_45proposesTtLRbOP5yrRENRm_45QNmscIT5knTaGth2ElJoa_45ll_EMeta } from "/opt/buildhome/repo/pages/engagement-ring-guide/time-to-propose.vue?macro=true";
import { default as _2000_45engagement_45ringsdZUm_45ydWBZsFMeQ7W9VdYdFGIIet7bzBWr2yyEndGwAMeta } from "/opt/buildhome/repo/pages/engagement-rings/2000-engagement-rings.vue?macro=true";
import { default as _3000_45engagement_45ringsqHb9jdMRGK8EjKtDcwdI_45Kg_1QvWvjRQsX1m_45IzQbogMeta } from "/opt/buildhome/repo/pages/engagement-rings/3000-engagement-rings.vue?macro=true";
import { default as _5000_45engagement_45ringsnVahKnD0IOoXPnwqocElseYAhn8ehiKr1rjHagXcU3MMeta } from "/opt/buildhome/repo/pages/engagement-rings/5000-engagement-rings.vue?macro=true";
import { default as jewelry_45engagement_45ringsmq5g_45isryC6xwF_45eISIb0KO2Quj6ApBWOAXBgc3Yh1QMeta } from "/opt/buildhome/repo/pages/wedding-rings/jewelry-engagement-rings.vue?macro=true";
import { default as complete_45the_45ringm_45R_yz8iiJNQZ8bbDBT7kTTKJ0krwzBP_45NKuaS7wpX4Meta } from "/opt/buildhome/repo/pages/engagement-ring-guide/complete-the-ring.vue?macro=true";
import { default as types_45of_45diamonds0EhBEgTZrP5RU7BjK78vEh7LBZQVxUgoqEC1QAFNKL8Meta } from "/opt/buildhome/repo/pages/engagement-ring-guide/types-of-diamonds.vue?macro=true";
import { default as _10000_45engagement_45ringsxuvbtCQfdT1nh8Bvd11019ymEvECc6hhVjEYYYHB5t4Meta } from "/opt/buildhome/repo/pages/engagement-rings/10000-engagement-rings.vue?macro=true";
import { default as exchange_45buyback_45policymJ9Y2RjwofFJBkZ_45fTILzVVq8lVB8RZbSYmw20C6fl8Meta } from "/opt/buildhome/repo/pages/customer-service/exchange-buyback-policy.vue?macro=true";
import { default as in_45stock_45engagement_45ring_45salebXQUZK6zYSJMNxs6f1e4_459wEVVT_45TGi6ykOOkLaM354Meta } from "/opt/buildhome/repo/pages/jewelry-sale/in-stock-engagement-ring-sale.vue?macro=true";
import { default as types_45of_45ring_45settingsAcyRp8Fyc_45DFXBEGwX8AO0IToSCWK7rxQraXz_qgC3YMeta } from "/opt/buildhome/repo/pages/engagement-ring-guide/types-of-ring-settings.vue?macro=true";
export default [
  {
    name: "cart___us",
    path: "/cart",
    component: () => import("/opt/buildhome/repo/pages/cart.vue")
  },
  {
    name: "cart___uk",
    path: "/uk/cart",
    component: () => import("/opt/buildhome/repo/pages/cart.vue")
  },
  {
    name: "index___us",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "login___us",
    path: "/login",
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___uk",
    path: "/uk/login",
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "press___us",
    path: "/press",
    component: () => import("/opt/buildhome/repo/pages/press.vue")
  },
  {
    name: "press___uk",
    path: "/uk/press",
    component: () => import("/opt/buildhome/repo/pages/press.vue")
  },
  {
    name: "search___us",
    path: "/search",
    component: () => import("/opt/buildhome/repo/pages/search.vue")
  },
  {
    name: "search___uk",
    path: "/uk/search",
    component: () => import("/opt/buildhome/repo/pages/search.vue")
  },
  {
    name: "isrtest___us",
    path: "/isrtest",
    component: () => import("/opt/buildhome/repo/pages/isrtest.vue")
  },
  {
    name: "isrtest___uk",
    path: "/uk/isrtest",
    component: () => import("/opt/buildhome/repo/pages/isrtest.vue")
  },
  {
    name: "sitemap___us",
    path: "/sitemap",
    component: () => import("/opt/buildhome/repo/pages/sitemap.vue")
  },
  {
    name: "sitemap___uk",
    path: "/uk/sitemap",
    component: () => import("/opt/buildhome/repo/pages/sitemap.vue")
  },
  {
    name: "about-us___us",
    path: "/about-us",
    component: () => import("/opt/buildhome/repo/pages/about-us.vue")
  },
  {
    name: "about-us___uk",
    path: "/uk/about-us",
    component: () => import("/opt/buildhome/repo/pages/about-us.vue")
  },
  {
    name: "register___us",
    path: "/register",
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "register___uk",
    path: "/uk/register",
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "franchise___us",
    path: "/franchise",
    meta: franchise5OqXjhO23rpOGtCZp1_455p9GNFolWlwLV7Y2IA3WwNIgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/franchise.vue")
  },
  {
    name: "franchise___uk",
    path: "/uk/franchise",
    meta: franchise5OqXjhO23rpOGtCZp1_455p9GNFolWlwLV7Y2IA3WwNIgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/franchise.vue")
  },
  {
    name: "our-story___us",
    path: "/our-story",
    component: () => import("/opt/buildhome/repo/pages/our-story.vue")
  },
  {
    name: "our-story___uk",
    path: "/uk/our-story",
    component: () => import("/opt/buildhome/repo/pages/our-story.vue")
  },
  {
    name: "affiliates___us",
    path: "/affiliates",
    meta: affiliatesLrTxRQFW6z6okdmdrgqUZOSzbUqTJZCcjCn8f8xi9LQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/affiliates.vue")
  },
  {
    name: "affiliates___uk",
    path: "/uk/affiliates",
    meta: affiliatesLrTxRQFW6z6okdmdrgqUZOSzbUqTJZCcjCn8f8xi9LQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/affiliates.vue")
  },
  {
    name: "contact-us___us",
    path: "/contact-us",
    component: () => import("/opt/buildhome/repo/pages/contact-us.vue")
  },
  {
    name: "contact-us___uk",
    path: "/uk/contact-us",
    component: () => import("/opt/buildhome/repo/pages/contact-us.vue")
  },
  {
    name: "blog-detail___us",
    path: "/blog/:slug()",
    meta: _91slug_93TVXfQgR7E_1etoF9MB3cfpp6TKNvvtjRnrJxWZr59DgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/blog/[slug].vue")
  },
  {
    name: "blog-detail___uk",
    path: "/uk/blog/:slug()",
    meta: _91slug_93TVXfQgR7E_1etoF9MB3cfpp6TKNvvtjRnrJxWZr59DgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/blog/[slug].vue")
  },
  {
    name: "4-cs-diamond___us",
    path: "/4-cs-diamond",
    component: () => import("/opt/buildhome/repo/pages/4-cs-diamond.vue")
  },
  {
    name: "4-cs-diamond___uk",
    path: "/uk/4-cs-diamond",
    component: () => import("/opt/buildhome/repo/pages/4-cs-diamond.vue")
  },
  {
    name: "free-product___us",
    path: "/free-product",
    component: () => import("/opt/buildhome/repo/pages/free-product.vue")
  },
  {
    name: "free-product___uk",
    path: "/uk/free-product",
    component: () => import("/opt/buildhome/repo/pages/free-product.vue")
  },
  {
    name: "lab-diamonds___us",
    path: "/lab-diamonds",
    component: () => import("/opt/buildhome/repo/pages/lab-diamonds.vue")
  },
  {
    name: "lab-diamonds___uk",
    path: "/uk/lab-diamonds",
    component: () => import("/opt/buildhome/repo/pages/lab-diamonds.vue")
  },
  {
    name: "share-moment___us",
    path: "/share-moment",
    component: () => import("/opt/buildhome/repo/pages/share-moment.vue")
  },
  {
    name: "share-moment___uk",
    path: "/uk/share-moment",
    component: () => import("/opt/buildhome/repo/pages/share-moment.vue")
  },
  {
    name: "shop-detail___us",
    path: "/:type(initial-necklaces|ready-to-ship-earrings|fashion-necklaces|soiree-cocktail-jewelry|soiree-cocktail-jewellery|colored-diamond-rings|wedding-band|womens-wedding-rings|couple-rings|eternity-rings|anniversary-rings|stud-earrings|hoop-earrings|fashion-earrings|tennis-bracelet|fashion-bracelets|tennis-necklace|solitaire-necklace|toi-et-moi-engagement-rings|ready-to-ship-engagement-rings|ready-to-ship-pendants|bangle-bracelets|rose-portrait-jewelry|rose-portrait-jewellery)/:slug(.*-\\d+)",
    meta: _91slug_93g7jc7sy03BcfUACnh4nHxOLHjzOIERBYrFLFeo5b5tQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/[type]/[slug].vue")
  },
  {
    name: "shop-detail___uk",
    path: "/uk/:type(initial-necklaces|ready-to-ship-earrings|fashion-necklaces|soiree-cocktail-jewelry|soiree-cocktail-jewellery|colored-diamond-rings|wedding-band|womens-wedding-rings|couple-rings|eternity-rings|anniversary-rings|stud-earrings|hoop-earrings|fashion-earrings|tennis-bracelet|fashion-bracelets|tennis-necklace|solitaire-necklace|toi-et-moi-engagement-rings|ready-to-ship-engagement-rings|ready-to-ship-pendants|bangle-bracelets|rose-portrait-jewelry|rose-portrait-jewellery)/:slug(.*-\\d+)",
    meta: _91slug_93g7jc7sy03BcfUACnh4nHxOLHjzOIERBYrFLFeo5b5tQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/[type]/[slug].vue")
  },
  {
    name: "cookie-policy___us",
    path: "/cookie-policy",
    component: () => import("/opt/buildhome/repo/pages/cookie-policy.vue")
  },
  {
    name: "cookie-policy___uk",
    path: "/uk/cookie-policy",
    component: () => import("/opt/buildhome/repo/pages/cookie-policy.vue")
  },
  {
    name: "account-detail___us",
    path: "/account/detail",
    meta: {"middleware":["sanctum:auth"]},
    component: () => import("/opt/buildhome/repo/pages/account/detail.vue")
  },
  {
    name: "account-detail___uk",
    path: "/uk/account/detail",
    meta: {"middleware":["sanctum:auth"]},
    component: () => import("/opt/buildhome/repo/pages/account/detail.vue")
  },
  {
    name: "privacy-policy___us",
    path: "/privacy-policy",
    component: () => import("/opt/buildhome/repo/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___uk",
    path: "/uk/privacy-policy",
    component: () => import("/opt/buildhome/repo/pages/privacy-policy.vue")
  },
  {
    name: "reset-password___us",
    path: "/reset-password",
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "reset-password___uk",
    path: "/uk/reset-password",
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "forgot-password___us",
    path: "/forgot-password",
    component: () => import("/opt/buildhome/repo/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___uk",
    path: "/uk/forgot-password",
    component: () => import("/opt/buildhome/repo/pages/forgot-password.vue")
  },
  {
    name: "cyo-complete-pendant___us",
    path: "/pendant/complete",
    meta: completeAYy90s8JXD0E1RYB9Z4RvyuDS0VCL_zy1fKk_YIbVFAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/pendant/complete.vue")
  },
  {
    name: "cyo-complete-pendant___uk",
    path: "/uk/pendant/complete",
    meta: completeAYy90s8JXD0E1RYB9Z4RvyuDS0VCL_zy1fKk_YIbVFAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/pendant/complete.vue")
  },
  {
    name: "terms-of-service___us",
    path: "/terms-of-service",
    component: () => import("/opt/buildhome/repo/pages/terms-of-service.vue")
  },
  {
    name: "terms-of-service___uk",
    path: "/uk/terms-of-service",
    component: () => import("/opt/buildhome/repo/pages/terms-of-service.vue")
  },
  {
    name: "appointment___us",
    path: "/appointment",
    component: () => import("/opt/buildhome/repo/pages/appointment/index.vue")
  },
  {
    name: "appointment___uk",
    path: "/uk/appointment",
    component: () => import("/opt/buildhome/repo/pages/appointment/index.vue")
  },
  {
    name: "cyo-complete-earring___us",
    path: "/earrings/complete",
    meta: completehEXMcwnoSuhODcV8KyYlPazMVsjZsh_9DSv8RLNaicYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/earrings/complete.vue")
  },
  {
    name: "cyo-complete-earring___uk",
    path: "/uk/earrings/complete",
    meta: completehEXMcwnoSuhODcV8KyYlPazMVsjZsh_9DSv8RLNaicYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/earrings/complete.vue")
  },
  {
    name: "our-share-of-care___us",
    path: "/our-share-of-care",
    component: () => import("/opt/buildhome/repo/pages/our-share-of-care.vue")
  },
  {
    name: "our-share-of-care___uk",
    path: "/uk/our-share-of-care",
    component: () => import("/opt/buildhome/repo/pages/our-share-of-care.vue")
  },
  {
    name: "checkout-thank-you___us",
    path: "/checkout/thank-you",
    component: () => import("/opt/buildhome/repo/pages/checkout/thank-you.vue")
  },
  {
    name: "checkout-thank-you___uk",
    path: "/uk/checkout/thank-you",
    component: () => import("/opt/buildhome/repo/pages/checkout/thank-you.vue")
  },
  {
    name: "customized-jewelry___us",
    path: "/customized-jewelry",
    component: () => import("/opt/buildhome/repo/pages/customized-jewelry.vue")
  },
  {
    name: "customized-jewelry___uk",
    path: "/uk/customise-jewellery",
    component: () => import("/opt/buildhome/repo/pages/customized-jewelry.vue")
  },
  {
    name: "fine-jewelry___us",
    path: "/fine-jewelry",
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/index.vue")
  },
  {
    name: "fine-jewelry___uk",
    path: "/uk/fine-jewellery",
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/index.vue")
  },
  {
    name: "high-jewelry-shop-all___us",
    path: "/high-jewelry",
    meta: indexvssrStqlunzQQexXqSVGueIAAX_aH4kyt9f6VjR2tkQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/high-jewelry/index.vue")
  },
  {
    name: "high-jewelry-shop-all___uk",
    path: "/uk/high-jewellery",
    meta: indexvssrStqlunzQQexXqSVGueIAAX_aH4kyt9f6VjR2tkQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/high-jewelry/index.vue")
  },
  {
    name: "jewelry-sale___us",
    path: "/jewelry-sale",
    meta: indexfhwMjPZUuHyhEz5TtJwJImBg83GpHipyrxzYQTG4opgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/jewelry-sale/index.vue")
  },
  {
    name: "jewelry-sale___uk",
    path: "/uk/jewellery-sale",
    meta: indexfhwMjPZUuHyhEz5TtJwJImBg83GpHipyrxzYQTG4opgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/jewelry-sale/index.vue")
  },
  {
    name: "jewelry-rings-sale___us",
    path: "/jewelry-sale/rings",
    meta: ringsUozITWYj4aa3p3jwbvVTLPD92Q_aHBDeyxR4QbZlG6gMeta || {},
    component: () => import("/opt/buildhome/repo/pages/jewelry-sale/rings.vue")
  },
  {
    name: "jewelry-rings-sale___uk",
    path: "/uk/jewellery-sale/rings",
    meta: ringsUozITWYj4aa3p3jwbvVTLPD92Q_aHBDeyxR4QbZlG6gMeta || {},
    component: () => import("/opt/buildhome/repo/pages/jewelry-sale/rings.vue")
  },
  {
    name: "testimonials___us",
    path: "/testimonials",
    component: () => import("/opt/buildhome/repo/pages/testimonials/index.vue")
  },
  {
    name: "testimonials___uk",
    path: "/uk/testimonials",
    component: () => import("/opt/buildhome/repo/pages/testimonials/index.vue")
  },
  {
    name: "account-orders-id___us",
    path: "/account/orders/:id()",
    meta: {"middleware":["sanctum:auth"]},
    component: () => import("/opt/buildhome/repo/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders-id___uk",
    path: "/uk/account/orders/:id()",
    meta: {"middleware":["sanctum:auth"]},
    component: () => import("/opt/buildhome/repo/pages/account/orders/[id].vue")
  },
  {
    name: "wedding-rings___us",
    path: "/wedding-rings",
    meta: indexqmAJvtNHDMZqiDCOcZ_45PyzrUXjhb7E8mDQurGys7ziIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/wedding-rings/index.vue")
  },
  {
    name: "wedding-rings___uk",
    path: "/uk/wedding-rings",
    meta: indexqmAJvtNHDMZqiDCOcZ_45PyzrUXjhb7E8mDQurGys7ziIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/wedding-rings/index.vue")
  },
  {
    name: "account-orders___us",
    path: "/account/orders",
    meta: {"middleware":["sanctum:auth"]},
    component: () => import("/opt/buildhome/repo/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___uk",
    path: "/uk/account/orders",
    meta: {"middleware":["sanctum:auth"]},
    component: () => import("/opt/buildhome/repo/pages/account/orders/index.vue")
  },
  {
    name: "appointment-services___us",
    path: "/appointment/services",
    component: () => import("/opt/buildhome/repo/pages/appointment/services.vue")
  },
  {
    name: "appointment-services___uk",
    path: "/uk/appointment/services",
    component: () => import("/opt/buildhome/repo/pages/appointment/services.vue")
  },
  {
    name: "appointment-thankyou___us",
    path: "/appointment/thankyou",
    component: () => import("/opt/buildhome/repo/pages/appointment/thankyou.vue")
  },
  {
    name: "appointment-thankyou___uk",
    path: "/uk/appointment/thankyou",
    component: () => import("/opt/buildhome/repo/pages/appointment/thankyou.vue")
  },
  {
    name: "customer-service-faq___us",
    path: "/customer-service/faq",
    meta: faqbp7fTPOakqAWJ5gVfpzD_58l_aHj04_45A_45eHTCbFkaNkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/customer-service/faq.vue")
  },
  {
    name: "customer-service-faq___uk",
    path: "/uk/customer-service/faq",
    meta: faqbp7fTPOakqAWJ5gVfpzD_58l_aHj04_45A_45eHTCbFkaNkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/customer-service/faq.vue")
  },
  {
    name: "shop-all-engagement-rings___us",
    path: "/engagement-rings/all",
    meta: allxt_0O3mprSnO2Pd5bNt7qOrPFP_45yXbsdzb2IAtA9RecMeta || {},
    component: () => import("/opt/buildhome/repo/pages/engagement-rings/all.vue")
  },
  {
    name: "shop-all-engagement-rings___uk",
    path: "/uk/engagement-rings/all",
    meta: allxt_0O3mprSnO2Pd5bNt7qOrPFP_45yXbsdzb2IAtA9RecMeta || {},
    component: () => import("/opt/buildhome/repo/pages/engagement-rings/all.vue")
  },
  {
    name: "appointment-know-more___us",
    path: "/appointment/know-more",
    component: () => import("/opt/buildhome/repo/pages/appointment/know-more.vue")
  },
  {
    name: "appointment-know-more___uk",
    path: "/uk/appointment/know-more",
    component: () => import("/opt/buildhome/repo/pages/appointment/know-more.vue")
  },
  {
    name: "how-to-find-ring-size___us",
    path: "/how-to-find-ring-size",
    component: () => import("/opt/buildhome/repo/pages/how-to-find-ring-size.vue")
  },
  {
    name: "how-to-find-ring-size___uk",
    path: "/uk/how-to-find-ring-size",
    component: () => import("/opt/buildhome/repo/pages/how-to-find-ring-size.vue")
  },
  {
    name: "jewelry-earrings-sale___us",
    path: "/jewelry-sale/earrings",
    meta: earrings1ZaumQUVxuRMXiVEEbKnavfNvv0Jrleafy8aK7spxVoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/jewelry-sale/earrings.vue")
  },
  {
    name: "jewelry-earrings-sale___uk",
    path: "/uk/jewellery-sale/earrings",
    meta: earrings1ZaumQUVxuRMXiVEEbKnavfNvv0Jrleafy8aK7spxVoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/jewelry-sale/earrings.vue")
  },
  {
    name: "preset-earrings___us",
    path: "/preset-earrings",
    meta: indexAREtN02BzTgjTZWylqv57NxnA7mg_458h8mJvXZqiMsZYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/preset-earrings/index.vue")
  },
  {
    name: "preset-earrings___uk",
    path: "/uk/preset-earrings",
    meta: indexAREtN02BzTgjTZWylqv57NxnA7mg_458h8mJvXZqiMsZYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/preset-earrings/index.vue")
  },
  {
    name: "preset-pendant___us",
    path: "/preset-pendants",
    meta: index5MTwZvqSoWIZTV2mVp2oz9EOaGTlO4rpbe3wFjwjscUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/preset-pendants/index.vue")
  },
  {
    name: "preset-pendant___uk",
    path: "/uk/preset-pendants",
    meta: index5MTwZvqSoWIZTV2mVp2oz9EOaGTlO4rpbe3wFjwjscUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/preset-pendants/index.vue")
  },
  {
    name: "rare-style-real-carat___us",
    path: "/rare-style-real-carat",
    meta: rare_45style_45real_45carat12bnudzGJz1StjEIxKO_GYQpAiGQDagekdZY5nIH5ZsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-style-real-carat.vue")
  },
  {
    name: "rare-style-real-carat___uk",
    path: "/uk/rare-style-real-carat",
    meta: rare_45style_45real_45carat12bnudzGJz1StjEIxKO_GYQpAiGQDagekdZY5nIH5ZsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/rare-style-real-carat.vue")
  },
  {
    name: "zales-it-with-jewelry___us",
    path: "/zales-it-with-jewelry",
    meta: zales_45it_45with_45jewelryM_45Z3kMELOcBgZ4NeIvbgKNv645LnDG4JlVvPFVBDHeAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/zales-it-with-jewelry.vue")
  },
  {
    name: "zales-it-with-jewelry___uk",
    path: "/uk/zales-it-with-jewelry",
    meta: zales_45it_45with_45jewelryM_45Z3kMELOcBgZ4NeIvbgKNv645LnDG4JlVvPFVBDHeAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/zales-it-with-jewelry.vue")
  },
  {
    name: "customer-service___us",
    path: "/customer-service",
    component: () => import("/opt/buildhome/repo/pages/customer-service/index.vue")
  },
  {
    name: "customer-service___uk",
    path: "/uk/customer-service",
    component: () => import("/opt/buildhome/repo/pages/customer-service/index.vue")
  },
  {
    name: "engagement-rings___us",
    path: "/engagement-rings",
    component: () => import("/opt/buildhome/repo/pages/engagement-rings/index.vue")
  },
  {
    name: "engagement-rings___uk",
    path: "/uk/engagement-rings",
    component: () => import("/opt/buildhome/repo/pages/engagement-rings/index.vue")
  },
  {
    name: "jewelry-bracelets-sale___us",
    path: "/jewelry-sale/bracelets",
    meta: braceletskEUB175santCJ5gXQqYOBqn_45tBQdN7IGsOyIXGkYaIEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/jewelry-sale/bracelets.vue")
  },
  {
    name: "jewelry-bracelets-sale___uk",
    path: "/uk/jewellery-sale/bracelets",
    meta: braceletskEUB175santCJ5gXQqYOBqn_45tBQdN7IGsOyIXGkYaIEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/jewelry-sale/bracelets.vue")
  },
  {
    name: "jewelry-necklaces-sale___us",
    path: "/jewelry-sale/necklaces",
    meta: necklacesSrhMadWhaFzzsJu9RxTKRsnxlpaCA1_gTHj_jVBmt0kMeta || {},
    component: () => import("/opt/buildhome/repo/pages/jewelry-sale/necklaces.vue")
  },
  {
    name: "jewelry-necklaces-sale___uk",
    path: "/uk/jewellery-sale/necklaces",
    meta: necklacesSrhMadWhaFzzsJu9RxTKRsnxlpaCA1_gTHj_jVBmt0kMeta || {},
    component: () => import("/opt/buildhome/repo/pages/jewelry-sale/necklaces.vue")
  },
  {
    name: "instock_earring___us",
    path: "/ready-to-ship-earrings",
    meta: ready_45to_45ship_45earringsN6_45lWakDU__45lfq0H2hKWIY5BhbE23y47bKMI5WgdmX0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/ready-to-ship-earrings.vue")
  },
  {
    name: "instock_earring___uk",
    path: "/uk/ready-to-ship-earrings",
    meta: ready_45to_45ship_45earringsN6_45lWakDU__45lfq0H2hKWIY5BhbE23y47bKMI5WgdmX0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/ready-to-ship-earrings.vue")
  },
  {
    name: "instock_pendant___us",
    path: "/ready-to-ship-pendants",
    meta: ready_45to_45ship_45pendantsXFynAAPDii02gpb21q2pygrEKbQvCCFXM_45De1y4eO5gMeta || {},
    component: () => import("/opt/buildhome/repo/pages/ready-to-ship-pendants.vue")
  },
  {
    name: "instock_pendant___uk",
    path: "/uk/ready-to-ship-pendants",
    meta: ready_45to_45ship_45pendantsXFynAAPDii02gpb21q2pygrEKbQvCCFXM_45De1y4eO5gMeta || {},
    component: () => import("/opt/buildhome/repo/pages/ready-to-ship-pendants.vue")
  },
  {
    name: "valentines-day-jewelry___us",
    path: "/valentines-day-jewelry",
    meta: valentines_45day_45jewelryGkaJvDS5VEAVpVI_MNKISYg45PB_hVG__b67DevWBzIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/valentines-day-jewelry.vue")
  },
  {
    name: "valentines-day-jewelry___uk",
    path: "/uk/valentines-day-jewelry",
    meta: valentines_45day_45jewelryGkaJvDS5VEAVpVI_MNKISYg45PB_hVG__b67DevWBzIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/valentines-day-jewelry.vue")
  },
  {
    name: "account-change-password___us",
    path: "/account/change-password",
    meta: {"middleware":["sanctum:auth"]},
    component: () => import("/opt/buildhome/repo/pages/account/change-password.vue")
  },
  {
    name: "account-change-password___uk",
    path: "/uk/account/change-password",
    meta: {"middleware":["sanctum:auth"]},
    component: () => import("/opt/buildhome/repo/pages/account/change-password.vue")
  },
  {
    name: "hues-ring-landing___us",
    path: "/high-jewelry/hues-rings",
    meta: hues_45ringst93q6GLqd2vHGdX7HSSur4TeKim4mGoYPQGg3mc1SdgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/high-jewelry/hues-rings.vue")
  },
  {
    name: "hues-ring-landing___uk",
    path: "/uk/high-jewellery/hues-rings",
    meta: hues_45ringst93q6GLqd2vHGdX7HSSur4TeKim4mGoYPQGg3mc1SdgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/high-jewelry/hues-rings.vue")
  },
  {
    name: "blue-vs-nile-ring-styles___us",
    path: "/blue-vs-nile-ring-styles",
    meta: blue_45vs_45nile_45ring_45stylesMMLE_45XJTtBNvQW6QhTIDGcdCmL5rgQtsnyRINo0uK5oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/blue-vs-nile-ring-styles.vue")
  },
  {
    name: "blue-vs-nile-ring-styles___uk",
    path: "/uk/blue-vs-nile-ring-styles",
    meta: blue_45vs_45nile_45ring_45stylesMMLE_45XJTtBNvQW6QhTIDGcdCmL5rgQtsnyRINo0uK5oMeta || {},
    component: () => import("/opt/buildhome/repo/pages/blue-vs-nile-ring-styles.vue")
  },
  {
    name: "checkout-sp___us",
    path: "/checkout/sp/:identifier()",
    meta: _91identifier_93zjXnlVrgeDAAU_45zA4Gyh_451Jk5vBOipq2aiMpC7PcWRwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/checkout/sp/[identifier].vue")
  },
  {
    name: "checkout-sp___uk",
    path: "/uk/checkout/sp/:identifier()",
    meta: _91identifier_93zjXnlVrgeDAAU_45zA4Gyh_451Jk5vBOipq2aiMpC7PcWRwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/checkout/sp/[identifier].vue")
  },
  {
    name: "cyo-complete-ring___us",
    path: "/engagement-ring/complete",
    meta: completelvF_Voc9uNnjZvlaeJ7_45bqVEO70wnBiQCLCuWDlanxAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/engagement-ring/complete.vue")
  },
  {
    name: "cyo-complete-ring___uk",
    path: "/uk/engagement-ring/complete",
    meta: completelvF_Voc9uNnjZvlaeJ7_45bqVEO70wnBiQCLCuWDlanxAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/engagement-ring/complete.vue")
  },
  {
    name: "inspiration-slug___us",
    path: "/inspiration-:slug()",
    meta: indexST7oesc4C3Ndk5vOHvvntJ_AHKVa06P90c6w1wQQqQMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/inspiration-[slug]/index.vue")
  },
  {
    name: "inspiration-slug___uk",
    path: "/uk/inspiration-:slug()",
    meta: indexST7oesc4C3Ndk5vOHvvntJ_AHKVa06P90c6w1wQQqQMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/inspiration-[slug]/index.vue")
  },
  {
    name: "jewelry-more-than-ok-kay___us",
    path: "/jewelry-more-than-ok-kay",
    meta: jewelry_45more_45than_45ok_45kay91f8N38z4U_N7KEmjjBWiB60NLbtyrOcVhjG7cTQ2SgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/jewelry-more-than-ok-kay.vue")
  },
  {
    name: "jewelry-more-than-ok-kay___uk",
    path: "/uk/jewelry-more-than-ok-kay",
    meta: jewelry_45more_45than_45ok_45kay91f8N38z4U_N7KEmjjBWiB60NLbtyrOcVhjG7cTQ2SgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/jewelry-more-than-ok-kay.vue")
  },
  {
    name: "light-performance-report___us",
    path: "/light-performance-report",
    component: () => import("/opt/buildhome/repo/pages/light-performance-report.vue")
  },
  {
    name: "light-performance-report___uk",
    path: "/uk/light-performance-report",
    component: () => import("/opt/buildhome/repo/pages/light-performance-report.vue")
  },
  {
    name: "account-appointments-id___us",
    path: "/account/appointments/:id()",
    meta: {"middleware":["sanctum:auth"]},
    component: () => import("/opt/buildhome/repo/pages/account/appointments/[id].vue")
  },
  {
    name: "account-appointments-id___uk",
    path: "/uk/account/appointments/:id()",
    meta: {"middleware":["sanctum:auth"]},
    component: () => import("/opt/buildhome/repo/pages/account/appointments/[id].vue")
  },
  {
    name: "recently-purchase-all___us",
    path: "/engagement-ring-for-women",
    meta: engagement_45ring_45for_45womenF41L6BQOmKH13oiicEzbq264Ds2KgJDfRF4kohn4zigMeta || {},
    component: () => import("/opt/buildhome/repo/pages/engagement-ring-for-women.vue")
  },
  {
    name: "recently-purchase-all___uk",
    path: "/uk/engagement-ring-for-women",
    meta: engagement_45ring_45for_45womenF41L6BQOmKH13oiicEzbq264Ds2KgJDfRF4kohn4zigMeta || {},
    component: () => import("/opt/buildhome/repo/pages/engagement-ring-for-women.vue")
  },
  {
    name: "testimonials-slug___us",
    path: "/testimonials/:slug()",
    component: () => import("/opt/buildhome/repo/pages/testimonials/[slug]/index.vue")
  },
  {
    name: "testimonials-slug___uk",
    path: "/uk/testimonials/:slug()",
    component: () => import("/opt/buildhome/repo/pages/testimonials/[slug]/index.vue")
  },
  {
    name: "account-appointments___us",
    path: "/account/appointments",
    meta: {"middleware":["sanctum:auth"]},
    component: () => import("/opt/buildhome/repo/pages/account/appointments/index.vue")
  },
  {
    name: "account-appointments___uk",
    path: "/uk/account/appointments",
    meta: {"middleware":["sanctum:auth"]},
    component: () => import("/opt/buildhome/repo/pages/account/appointments/index.vue")
  },
  {
    name: "blog-listing___us",
    path: "/blog/:type?/:sub_type?",
    meta: _91_91sub_type_93_93jWZv2Tf6ZViVEyFFuRuF1H6I_jBLca9WuBY_45P6dwyDwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/blog/[[type]]/[[sub_type]].vue")
  },
  {
    name: "blog-listing___uk",
    path: "/uk/blog/:type?/:sub_type?",
    meta: _91_91sub_type_93_93jWZv2Tf6ZViVEyFFuRuF1H6I_jBLca9WuBY_45P6dwyDwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/blog/[[type]]/[[sub_type]].vue")
  },
  {
    name: "shop-hoop___us",
    path: "/fine-jewelry/hoop-earrings",
    meta: hoop_45earringsay1QreO04J_Oetvto7fP_ahuruaGe5VgIEumX3ULxVsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/hoop-earrings.vue")
  },
  {
    name: "shop-hoop___uk",
    path: "/uk/fine-jewellery/hoop-earrings",
    meta: hoop_45earringsay1QreO04J_Oetvto7fP_ahuruaGe5VgIEumX3ULxVsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/hoop-earrings.vue")
  },
  {
    name: "shop-earring___us",
    path: "/fine-jewelry/stud-earrings",
    meta: stud_45earringsGv8Z60Vc1j7mI0E9gb5vcDCFbgn7dnUzYUHsRkOwjcUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/stud-earrings.vue")
  },
  {
    name: "shop-earring___uk",
    path: "/uk/fine-jewellery/stud-earrings",
    meta: stud_45earringsGv8Z60Vc1j7mI0E9gb5vcDCFbgn7dnUzYUHsRkOwjcUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/stud-earrings.vue")
  },
  {
    name: "green-and-sustainable-gift___us",
    path: "/green-and-sustainable-gift",
    component: () => import("/opt/buildhome/repo/pages/green-and-sustainable-gift.vue")
  },
  {
    name: "green-and-sustainable-gift___uk",
    path: "/uk/green-and-sustainable-gift",
    component: () => import("/opt/buildhome/repo/pages/green-and-sustainable-gift.vue")
  },
  {
    name: "cyo-setting-detail-ring___us",
    path: "/ring-settings/:slug(.*-\\d+)",
    meta: indexs33_Kr3tRW7sitJh_45uZgY6XgAJkoWf97xNoRsZsnRJgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/ring-settings/[slug]/index.vue")
  },
  {
    name: "cyo-setting-detail-ring___uk",
    path: "/uk/ring-settings/:slug(.*-\\d+)",
    meta: indexs33_Kr3tRW7sitJh_45uZgY6XgAJkoWf97xNoRsZsnRJgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/ring-settings/[slug]/index.vue")
  },
  {
    name: "shop-couple-rings___us",
    path: "/wedding-rings/couple-rings",
    meta: couple_45ringsZUAWlM5P4X9YDSk_45BJsIMNa7f17h4_454uyGcPd0iTbpMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/wedding-rings/couple-rings.vue")
  },
  {
    name: "shop-couple-rings___uk",
    path: "/uk/wedding-rings/couple-rings",
    meta: couple_45ringsZUAWlM5P4X9YDSk_45BJsIMNa7f17h4_454uyGcPd0iTbpMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/wedding-rings/couple-rings.vue")
  },
  {
    name: "engagement-ring-guide___us",
    path: "/engagement-ring-guide",
    component: () => import("/opt/buildhome/repo/pages/engagement-ring-guide/index.vue")
  },
  {
    name: "engagement-ring-guide___uk",
    path: "/uk/engagement-ring-guide",
    component: () => import("/opt/buildhome/repo/pages/engagement-ring-guide/index.vue")
  },
  {
    name: "friendly-diamond-difference___us",
    path: "/friendly-diamond-difference",
    component: () => import("/opt/buildhome/repo/pages/friendly-diamond-difference.vue")
  },
  {
    name: "friendly-diamond-difference___uk",
    path: "/uk/friendly-diamond-difference",
    component: () => import("/opt/buildhome/repo/pages/friendly-diamond-difference.vue")
  },
  {
    name: "loose-detail___us",
    path: "/loose-diamonds/:slug(.*-\\d+)",
    meta: index78t2QXkBt5jJ7yEtneefqPF2SQrKIicfGqOKVGUODG4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/loose-diamonds/[slug]/index.vue")
  },
  {
    name: "loose-detail___uk",
    path: "/uk/loose-diamonds/:slug(.*-\\d+)",
    meta: index78t2QXkBt5jJ7yEtneefqPF2SQrKIicfGqOKVGUODG4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/loose-diamonds/[slug]/index.vue")
  },
  {
    name: "toi-et-moi-ring___us",
    path: "/toi-et-moi-engagement-rings",
    meta: toi_45et_45moi_45engagement_45ringsD_TP4uY97fCG9z74GuYDVpUU1WEqvNAJXCAElh6_2_45YMeta || {},
    component: () => import("/opt/buildhome/repo/pages/toi-et-moi-engagement-rings.vue")
  },
  {
    name: "toi-et-moi-ring___uk",
    path: "/uk/toi-et-moi-engagement-rings",
    meta: toi_45et_45moi_45engagement_45ringsD_TP4uY97fCG9z74GuYDVpUU1WEqvNAJXCAElh6_2_45YMeta || {},
    component: () => import("/opt/buildhome/repo/pages/toi-et-moi-engagement-rings.vue")
  },
  {
    name: "preset-earring-detail___us",
    path: "/preset-earrings/:slug()",
    meta: indexukLSQLMXpugCm_4SxXpqp0gI7IBkUUAphWMToAuAW3cMeta || {},
    component: () => import("/opt/buildhome/repo/pages/preset-earrings/[slug]/index.vue")
  },
  {
    name: "preset-earring-detail___uk",
    path: "/uk/preset-earrings/:slug()",
    meta: indexukLSQLMXpugCm_4SxXpqp0gI7IBkUUAphWMToAuAW3cMeta || {},
    component: () => import("/opt/buildhome/repo/pages/preset-earrings/[slug]/index.vue")
  },
  {
    name: "preset-pendant-detail___us",
    path: "/preset-pendants/:slug()",
    meta: indexHX_450XKDLnc28CXx4J1yr39oAV_45bPv0sLNzNeaK4FU_sMeta || {},
    component: () => import("/opt/buildhome/repo/pages/preset-pendants/[slug]/index.vue")
  },
  {
    name: "preset-pendant-detail___uk",
    path: "/uk/preset-pendants/:slug()",
    meta: indexHX_450XKDLnc28CXx4J1yr39oAV_45bPv0sLNzNeaK4FU_sMeta || {},
    component: () => import("/opt/buildhome/repo/pages/preset-pendants/[slug]/index.vue")
  },
  {
    name: "cyo-setting-list-ring___us",
    path: "/ring-settings/:start_with([a-zA-Z-]*[a-zA-Z])?",
    meta: _91_91start_with_93_93auYXyTpJEbhdvzVqhrInWLs5Yw35tGyJSo84dq08Dl8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/ring-settings/[[start_with]].vue")
  },
  {
    name: "cyo-setting-list-ring___uk",
    path: "/uk/ring-settings/:start_with([a-zA-Z-]*[a-zA-Z])?",
    meta: _91_91start_with_93_93auYXyTpJEbhdvzVqhrInWLs5Yw35tGyJSo84dq08Dl8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/ring-settings/[[start_with]].vue")
  },
  {
    name: "shop-eternity___us",
    path: "/wedding-rings/eternity-rings",
    meta: eternity_45ringscCHk2HBgGKUAFUb_45h7WhXdtfE_451XbFbFvTZbs3jvFLkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/wedding-rings/eternity-rings.vue")
  },
  {
    name: "shop-eternity___uk",
    path: "/uk/wedding-rings/eternity-rings",
    meta: eternity_45ringscCHk2HBgGKUAFUb_45h7WhXdtfE_451XbFbFvTZbs3jvFLkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/wedding-rings/eternity-rings.vue")
  },
  {
    name: "recently-purchase-shape___us",
    path: "/:slug()-engagement-rings",
    meta: indexi_45fm653dEwFGNM8YGx2es67xWs0PbTpTkU7OpONgvbwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/[slug]-engagement-rings/index.vue")
  },
  {
    name: "recently-purchase-shape___uk",
    path: "/uk/:slug()-engagement-rings",
    meta: indexi_45fm653dEwFGNM8YGx2es67xWs0PbTpTkU7OpONgvbwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/[slug]-engagement-rings/index.vue")
  },
  {
    name: "brilliance-in-lab-grown-rings___us",
    path: "/brilliance-in-lab-grown-rings",
    meta: brilliance_45in_45lab_45grown_45ringskTuN2rTHBgO84pMhnr4unm70qBkCcAeoxCx7_457YiHq0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/brilliance-in-lab-grown-rings.vue")
  },
  {
    name: "brilliance-in-lab-grown-rings___uk",
    path: "/uk/brilliance-in-lab-grown-rings",
    meta: brilliance_45in_45lab_45grown_45ringskTuN2rTHBgO84pMhnr4unm70qBkCcAeoxCx7_457YiHq0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/brilliance-in-lab-grown-rings.vue")
  },
  {
    name: "cyo-setting-detail-earring___us",
    path: "/earring-settings/:slug(.*-\\d+)",
    meta: indexrjYkHnWmLDSySgEaeobE86gV9Gl6_DABINwWs2d_BdMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/earring-settings/[slug]/index.vue")
  },
  {
    name: "cyo-setting-detail-earring___uk",
    path: "/uk/earring-settings/:slug(.*-\\d+)",
    meta: indexrjYkHnWmLDSySgEaeobE86gV9Gl6_DABINwWs2d_BdMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/earring-settings/[slug]/index.vue")
  },
  {
    name: "shop-bangle-bracelet___us",
    path: "/fine-jewelry/bangle-bracelets",
    meta: bangle_45bracelets1D0W5nRIBpMaD9ttVGg8Y9m0Lz320jx3TENnD8O_45tDMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/bangle-bracelets.vue")
  },
  {
    name: "shop-bangle-bracelet___uk",
    path: "/uk/fine-jewellery/bangle-bracelets",
    meta: bangle_45bracelets1D0W5nRIBpMaD9ttVGg8Y9m0Lz320jx3TENnD8O_45tDMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/bangle-bracelets.vue")
  },
  {
    name: "shop-fashion-earring___us",
    path: "/fine-jewelry/fashion-earrings",
    meta: fashion_45earringsajH7Bcv99KEZ0RM7_Lm3VjXkm6QMzvHWkBVImnh8ZDUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/fashion-earrings.vue")
  },
  {
    name: "shop-fashion-earring___uk",
    path: "/uk/fine-jewellery/fashion-earrings",
    meta: fashion_45earringsajH7Bcv99KEZ0RM7_Lm3VjXkm6QMzvHWkBVImnh8ZDUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/fashion-earrings.vue")
  },
  {
    name: "shop-bracelet___us",
    path: "/fine-jewelry/tennis-bracelets",
    meta: tennis_45braceletsMzEE2E_RwsgjojzGrHU7YXWCS2_XOSXwDqJ8LB19cEwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/tennis-bracelets.vue")
  },
  {
    name: "shop-bracelet___uk",
    path: "/uk/fine-jewellery/tennis-bracelets",
    meta: tennis_45braceletsMzEE2E_RwsgjojzGrHU7YXWCS2_XOSXwDqJ8LB19cEwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/tennis-bracelets.vue")
  },
  {
    name: "shop-tennis-necklace___us",
    path: "/fine-jewelry/tennis-necklaces",
    meta: tennis_45necklaces5rKcBKocWAG0FFaiyUgDHIeKVE2sEGK3eiWH6PMRNr4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/tennis-necklaces.vue")
  },
  {
    name: "shop-tennis-necklace___uk",
    path: "/uk/fine-jewellery/tennis-necklaces",
    meta: tennis_45necklaces5rKcBKocWAG0FFaiyUgDHIeKVE2sEGK3eiWH6PMRNr4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/tennis-necklaces.vue")
  },
  {
    name: "loose-listing___us",
    path: "/loose-diamonds/:start_with(round-cut-diamond|oval-cut-diamond|pear-cut-diamond|cushion-cut-diamond|princess-cut-diamond|radiant-cut-diamond|emerald-cut-diamond|asscher-cut-diamond|marquise-cut-diamond|heart-cut-diamond|gia-certified|igi-certified)?",
    meta: _91_91start_with_93_93SxhIi6C3xLTQGVeulfwHT7alIweAoK1fnlJox54Xj34Meta || {},
    component: () => import("/opt/buildhome/repo/pages/loose-diamonds/[[start_with]].vue")
  },
  {
    name: "loose-listing___uk",
    path: "/uk/loose-diamonds/:start_with(round-cut-diamond|oval-cut-diamond|pear-cut-diamond|cushion-cut-diamond|princess-cut-diamond|radiant-cut-diamond|emerald-cut-diamond|asscher-cut-diamond|marquise-cut-diamond|heart-cut-diamond|gia-certified|igi-certified)?",
    meta: _91_91start_with_93_93SxhIi6C3xLTQGVeulfwHT7alIweAoK1fnlJox54Xj34Meta || {},
    component: () => import("/opt/buildhome/repo/pages/loose-diamonds/[[start_with]].vue")
  },
  {
    name: "cyo-setting-detail-pendant___us",
    path: "/pendant-settings/:slug(.*-\\d+)",
    meta: index_xQy4JWk8i6GP8uWSBkvLxJxPYUKWmZU1V60ZtHdqjMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/pendant-settings/[slug]/index.vue")
  },
  {
    name: "cyo-setting-detail-pendant___uk",
    path: "/uk/pendant-settings/:slug(.*-\\d+)",
    meta: index_xQy4JWk8i6GP8uWSBkvLxJxPYUKWmZU1V60ZtHdqjMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/pendant-settings/[slug]/index.vue")
  },
  {
    name: "preset-listing___us",
    path: "/preset-engagement-rings",
    meta: indexh_45YIJ4OUNSUrjlyngVBhl9UDBluZGohax_45TqGK8joiQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/preset-engagement-rings/index.vue")
  },
  {
    name: "preset-listing___uk",
    path: "/uk/preset-engagement-rings",
    meta: indexh_45YIJ4OUNSUrjlyngVBhl9UDBluZGohax_45TqGK8joiQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/preset-engagement-rings/index.vue")
  },
  {
    name: "customer-service-return-policy___us",
    path: "/customer-service/return-policy",
    component: () => import("/opt/buildhome/repo/pages/customer-service/return-policy.vue")
  },
  {
    name: "customer-service-return-policy___uk",
    path: "/uk/customer-service/return-policy",
    component: () => import("/opt/buildhome/repo/pages/customer-service/return-policy.vue")
  },
  {
    name: "customer-service-ring-resizing___us",
    path: "/customer-service/ring-resizing",
    component: () => import("/opt/buildhome/repo/pages/customer-service/ring-resizing.vue")
  },
  {
    name: "customer-service-ring-resizing___uk",
    path: "/uk/customer-service/ring-resizing",
    component: () => import("/opt/buildhome/repo/pages/customer-service/ring-resizing.vue")
  },
  {
    name: "shop-all___us",
    path: "/diamond-jewelry/:start_with?",
    meta: _91_91start_with_93_93tF_45VZc7vRIm0FHckrKofUDf2HZgyJb3Bbii9sRQcQIkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/diamond-jewelry/[[start_with]].vue")
  },
  {
    name: "shop-all___uk",
    path: "/uk/diamond-jewellery/:start_with?",
    meta: _91_91start_with_93_93tF_45VZc7vRIm0FHckrKofUDf2HZgyJb3Bbii9sRQcQIkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/diamond-jewelry/[[start_with]].vue")
  },
  {
    name: "shop-fashion-bracelet___us",
    path: "/fine-jewelry/fashion-bracelets",
    meta: fashion_45bracelets_f6QLeuW1fGGorBPTqcOJmCigRUy1rjwr07LzJIGX4sMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/fashion-bracelets.vue")
  },
  {
    name: "shop-fashion-bracelet___uk",
    path: "/uk/fine-jewellery/fashion-bracelets",
    meta: fashion_45bracelets_f6QLeuW1fGGorBPTqcOJmCigRUy1rjwr07LzJIGX4sMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/fashion-bracelets.vue")
  },
  {
    name: "shop-fashion-necklace___us",
    path: "/fine-jewelry/fashion-necklaces",
    meta: fashion_45necklacesKkco2lYmQzNbJ6TKzH4w__Ksc7RdJKp0AeRjc502Cy0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/fashion-necklaces.vue")
  },
  {
    name: "shop-fashion-necklace___uk",
    path: "/uk/fine-jewellery/fashion-necklaces",
    meta: fashion_45necklacesKkco2lYmQzNbJ6TKzH4w__Ksc7RdJKp0AeRjc502Cy0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/fashion-necklaces.vue")
  },
  {
    name: "shop-initial-necklace___us",
    path: "/fine-jewelry/initial-necklaces",
    meta: initial_45necklaces9kL4y_45pVAdDS2MHczpAij5vrrX9TLMMYqvpjDNR7ay0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/initial-necklaces.vue")
  },
  {
    name: "shop-initial-necklace___uk",
    path: "/uk/fine-jewellery/initial-necklaces",
    meta: initial_45necklaces9kL4y_45pVAdDS2MHczpAij5vrrX9TLMMYqvpjDNR7ay0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/initial-necklaces.vue")
  },
  {
    name: "instock_ring___us",
    path: "/ready-to-ship-engagement-rings",
    meta: ready_45to_45ship_45engagement_45rings2bKy5NJxdkTKEjE4Os4N2juUn5Rg15dTs_Qp_XOmDxsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/ready-to-ship-engagement-rings.vue")
  },
  {
    name: "instock_ring___uk",
    path: "/uk/ready-to-ship-engagement-rings",
    meta: ready_45to_45ship_45engagement_45rings2bKy5NJxdkTKEjE4Os4N2juUn5Rg15dTs_Qp_XOmDxsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/ready-to-ship-engagement-rings.vue")
  },
  {
    name: "customer-service-ring-engraving___us",
    path: "/customer-service/ring-engraving",
    component: () => import("/opt/buildhome/repo/pages/customer-service/ring-engraving.vue")
  },
  {
    name: "customer-service-ring-engraving___uk",
    path: "/uk/customer-service/ring-engraving",
    component: () => import("/opt/buildhome/repo/pages/customer-service/ring-engraving.vue")
  },
  {
    name: "cyo-setting-list-earring___us",
    path: "/earring-settings/:start_with([a-zA-Z-]*[a-zA-Z])?",
    meta: _91_91start_with_93_93W8cHSCUiWdbJuEKS8LP9ZMU2bQQsMHbQYw4yWgDaeqsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/earring-settings/[[start_with]].vue")
  },
  {
    name: "cyo-setting-list-earring___uk",
    path: "/uk/earring-settings/:start_with([a-zA-Z-]*[a-zA-Z])?",
    meta: _91_91start_with_93_93W8cHSCUiWdbJuEKS8LP9ZMU2bQQsMHbQYw4yWgDaeqsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/earring-settings/[[start_with]].vue")
  },
  {
    name: "engagement-ring-guide-ring-cost___us",
    path: "/engagement-ring-guide/ring-cost",
    component: () => import("/opt/buildhome/repo/pages/engagement-ring-guide/ring-cost.vue")
  },
  {
    name: "engagement-ring-guide-ring-cost___uk",
    path: "/uk/engagement-ring-guide/ring-cost",
    component: () => import("/opt/buildhome/repo/pages/engagement-ring-guide/ring-cost.vue")
  },
  {
    name: "cyo-setting-list-pendant___us",
    path: "/pendant-settings/:start_with([a-zA-Z-]*[a-zA-Z])?",
    meta: _91_91start_with_93_93YqEARdqPiJsciL9dNFnmzg_45Hy2JlLhitO1BOnFgKWAoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/pendant-settings/[[start_with]].vue")
  },
  {
    name: "cyo-setting-list-pendant___uk",
    path: "/uk/pendant-settings/:start_with([a-zA-Z-]*[a-zA-Z])?",
    meta: _91_91start_with_93_93YqEARdqPiJsciL9dNFnmzg_45Hy2JlLhitO1BOnFgKWAoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/pendant-settings/[[start_with]].vue")
  },
  {
    name: "shop-anniversary___us",
    path: "/wedding-rings/anniversary-rings",
    meta: anniversary_45ringsAUNcf4MtM3eEbr9kfw7taMYN3hTQ8H3pMU0GgzTH3iQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/wedding-rings/anniversary-rings.vue")
  },
  {
    name: "shop-anniversary___uk",
    path: "/uk/wedding-rings/anniversary-rings",
    meta: anniversary_45ringsAUNcf4MtM3eEbr9kfw7taMYN3hTQ8H3pMU0GgzTH3iQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/wedding-rings/anniversary-rings.vue")
  },
  {
    name: "recently-purchase-carat___us",
    path: "/:slug()-carat-diamond-rings",
    meta: indexSIIrqcns3yQldrdyt0i0Gyp8L87fdxKknkg7HpJnrXEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/[slug]-carat-diamond-rings/index.vue")
  },
  {
    name: "recently-purchase-carat___uk",
    path: "/uk/:slug()-carat-diamond-rings",
    meta: indexSIIrqcns3yQldrdyt0i0Gyp8L87fdxKknkg7HpJnrXEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/[slug]-carat-diamond-rings/index.vue")
  },
  {
    name: "customer-service-exchange-policy___us",
    path: "/customer-service/exchange-policy",
    component: () => import("/opt/buildhome/repo/pages/customer-service/exchange-policy.vue")
  },
  {
    name: "customer-service-exchange-policy___uk",
    path: "/uk/customer-service/exchange-policy",
    component: () => import("/opt/buildhome/repo/pages/customer-service/exchange-policy.vue")
  },
  {
    name: "customer-service-payment-options___us",
    path: "/customer-service/payment-options",
    meta: payment_45options5WCfmcJnaV7KeMHz0Dlij9fzLNgeVZ39uv0IPMXnfHwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/customer-service/payment-options.vue")
  },
  {
    name: "customer-service-payment-options___uk",
    path: "/uk/customer-service/payment-options",
    meta: payment_45options5WCfmcJnaV7KeMHz0Dlij9fzLNgeVZ39uv0IPMXnfHwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/customer-service/payment-options.vue")
  },
  {
    name: "customer-service-shipping-policy___us",
    path: "/customer-service/shipping-policy",
    component: () => import("/opt/buildhome/repo/pages/customer-service/shipping-policy.vue")
  },
  {
    name: "customer-service-shipping-policy___uk",
    path: "/uk/customer-service/shipping-policy",
    component: () => import("/opt/buildhome/repo/pages/customer-service/shipping-policy.vue")
  },
  {
    name: "shop-solitaire-necklace___us",
    path: "/fine-jewelry/solitaire-necklaces",
    meta: solitaire_45necklacesNH0JvWLRwgx143X5V0cyamVRct8GVa_45RunE4ZpSu25YMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/solitaire-necklaces.vue")
  },
  {
    name: "shop-solitaire-necklace___uk",
    path: "/uk/fine-jewellery/solitaire-necklaces",
    meta: solitaire_45necklacesNH0JvWLRwgx143X5V0cyamVRct8GVa_45RunE4ZpSu25YMeta || {},
    component: () => import("/opt/buildhome/repo/pages/fine-jewelry/solitaire-necklaces.vue")
  },
  {
    name: "brilliant-and-earth-friendly-rings___us",
    path: "/brilliant-and-earth-friendly-rings",
    meta: brilliant_45and_45earth_45friendly_45rings4URHaibDZ7pF2GDTj7B3SgmTegEN_jUC5t6Xko7bmjcMeta || {},
    component: () => import("/opt/buildhome/repo/pages/brilliant-and-earth-friendly-rings.vue")
  },
  {
    name: "brilliant-and-earth-friendly-rings___uk",
    path: "/uk/brilliant-and-earth-friendly-rings",
    meta: brilliant_45and_45earth_45friendly_45rings4URHaibDZ7pF2GDTj7B3SgmTegEN_jUC5t6Xko7bmjcMeta || {},
    component: () => import("/opt/buildhome/repo/pages/brilliant-and-earth-friendly-rings.vue")
  },
  {
    name: "ethical-and-conflict-free-diamonds___us",
    path: "/ethical-and-conflict-free-diamonds",
    component: () => import("/opt/buildhome/repo/pages/ethical-and-conflict-free-diamonds.vue")
  },
  {
    name: "ethical-and-conflict-free-diamonds___uk",
    path: "/uk/ethical-and-conflict-free-diamonds",
    component: () => import("/opt/buildhome/repo/pages/ethical-and-conflict-free-diamonds.vue")
  },
  {
    name: "shop-colored-diamond-rings___us",
    path: "/high-jewelry/colored-diamond-rings",
    meta: colored_45diamond_45ringscBEBxrWKTK99IAV3wa1kag1uGElng6Wps8qkXd8N8cAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/high-jewelry/colored-diamond-rings.vue")
  },
  {
    name: "shop-colored-diamond-rings___uk",
    path: "/uk/high-jewellery/colored-diamond-rings",
    meta: colored_45diamond_45ringscBEBxrWKTK99IAV3wa1kag1uGElng6Wps8qkXd8N8cAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/high-jewelry/colored-diamond-rings.vue")
  },
  {
    name: "shop-rose-portrait-jewelry___us",
    path: "/high-jewelry/rose-portrait-jewelry",
    meta: rose_45portrait_45jewelryycxu4zTR4Je7pOT3GT55ToreqqVp7Znbuz_hwHua_ZcMeta || {},
    component: () => import("/opt/buildhome/repo/pages/high-jewelry/rose-portrait-jewelry.vue")
  },
  {
    name: "shop-rose-portrait-jewelry___uk",
    path: "/uk/high-jewellery/rose-portrait-jewellery",
    meta: rose_45portrait_45jewelryycxu4zTR4Je7pOT3GT55ToreqqVp7Znbuz_hwHua_ZcMeta || {},
    component: () => import("/opt/buildhome/repo/pages/high-jewelry/rose-portrait-jewelry.vue")
  },
  {
    name: "james-and-allen-found-perfect-ring___us",
    path: "/james-and-allen-found-perfect-ring",
    meta: james_45and_45allen_45found_45perfect_45ringDYhj9cXJ_456_45o66FHed0N51_U_45ThfxBi4vNMiG3wwNqgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/james-and-allen-found-perfect-ring.vue")
  },
  {
    name: "james-and-allen-found-perfect-ring___uk",
    path: "/uk/james-and-allen-found-perfect-ring",
    meta: james_45and_45allen_45found_45perfect_45ringDYhj9cXJ_456_45o66FHed0N51_U_45ThfxBi4vNMiG3wwNqgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/james-and-allen-found-perfect-ring.vue")
  },
  {
    name: "shop-womens-wedding-rings___us",
    path: "/wedding-rings/womens-wedding-rings",
    meta: womens_45wedding_45rings3cR3C_GLQfntQ7Z0zvvbCbnb1a4P5nFVVOuWZ5aWU8IMeta || {},
    component: () => import("/opt/buildhome/repo/pages/wedding-rings/womens-wedding-rings.vue")
  },
  {
    name: "shop-womens-wedding-rings___uk",
    path: "/uk/wedding-rings/womens-wedding-rings",
    meta: womens_45wedding_45rings3cR3C_GLQfntQ7Z0zvvbCbnb1a4P5nFVVOuWZ5aWU8IMeta || {},
    component: () => import("/opt/buildhome/repo/pages/wedding-rings/womens-wedding-rings.vue")
  },
  {
    name: "customer-service-life-time-warranty___us",
    path: "/customer-service/life-time-warranty",
    component: () => import("/opt/buildhome/repo/pages/customer-service/life-time-warranty.vue")
  },
  {
    name: "customer-service-life-time-warranty___uk",
    path: "/uk/customer-service/life-time-warranty",
    component: () => import("/opt/buildhome/repo/pages/customer-service/life-time-warranty.vue")
  },
  {
    name: "shop-soiree-cocktail-jewelry___us",
    path: "/high-jewelry/soiree-cocktail-jewelry",
    meta: soiree_45cocktail_45jewelryO_L4v1FGuxNYuEm2JPrVZW33PsiLy5BwMnnYGoqhIx8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/high-jewelry/soiree-cocktail-jewelry.vue")
  },
  {
    name: "shop-soiree-cocktail-jewelry___uk",
    path: "/uk/high-jewellery/soiree-cocktail-jewellery",
    meta: soiree_45cocktail_45jewelryO_L4v1FGuxNYuEm2JPrVZW33PsiLy5BwMnnYGoqhIx8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/high-jewelry/soiree-cocktail-jewelry.vue")
  },
  {
    name: "preset-detail___us",
    path: "/preset-engagement-rings/:slug()",
    meta: indexcIjYRUT7RcamWsEnao_XF0IwwGEHdcgQ0crd3el_458tIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/preset-engagement-rings/[slug]/index.vue")
  },
  {
    name: "preset-detail___uk",
    path: "/uk/preset-engagement-rings/:slug()",
    meta: indexcIjYRUT7RcamWsEnao_XF0IwwGEHdcgQ0crd3el_458tIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/preset-engagement-rings/[slug]/index.vue")
  },
  {
    name: "proposal-solutions-by-shane-co-o-per___us",
    path: "/proposal-solutions-by-shane-co-o-per",
    meta: proposal_45solutions_45by_45shane_45co_45o_45perD3SGecufPur4uvsm8tdAheTYces4cbRNB7ROGOFFJugMeta || {},
    component: () => import("/opt/buildhome/repo/pages/proposal-solutions-by-shane-co-o-per.vue")
  },
  {
    name: "proposal-solutions-by-shane-co-o-per___uk",
    path: "/uk/proposal-solutions-by-shane-co-o-per",
    meta: proposal_45solutions_45by_45shane_45co_45o_45perD3SGecufPur4uvsm8tdAheTYces4cbRNB7ROGOFFJugMeta || {},
    component: () => import("/opt/buildhome/repo/pages/proposal-solutions-by-shane-co-o-per.vue")
  },
  {
    name: "engagement-ring-guide-time-to-propose___us",
    path: "/engagement-ring-guide/time-to-propose",
    component: () => import("/opt/buildhome/repo/pages/engagement-ring-guide/time-to-propose.vue")
  },
  {
    name: "engagement-ring-guide-time-to-propose___uk",
    path: "/uk/engagement-ring-guide/time-to-propose",
    component: () => import("/opt/buildhome/repo/pages/engagement-ring-guide/time-to-propose.vue")
  },
  {
    name: "shop-2000-engagement-rings___us",
    path: "/engagement-rings/2000-engagement-rings",
    meta: _2000_45engagement_45ringsdZUm_45ydWBZsFMeQ7W9VdYdFGIIet7bzBWr2yyEndGwAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/engagement-rings/2000-engagement-rings.vue")
  },
  {
    name: "shop-2000-engagement-rings___uk",
    path: "/uk/engagement-rings/2000-engagement-rings",
    meta: _2000_45engagement_45ringsdZUm_45ydWBZsFMeQ7W9VdYdFGIIet7bzBWr2yyEndGwAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/engagement-rings/2000-engagement-rings.vue")
  },
  {
    name: "shop-3000-engagement-rings___us",
    path: "/engagement-rings/3000-engagement-rings",
    meta: _3000_45engagement_45ringsqHb9jdMRGK8EjKtDcwdI_45Kg_1QvWvjRQsX1m_45IzQbogMeta || {},
    component: () => import("/opt/buildhome/repo/pages/engagement-rings/3000-engagement-rings.vue")
  },
  {
    name: "shop-3000-engagement-rings___uk",
    path: "/uk/engagement-rings/3000-engagement-rings",
    meta: _3000_45engagement_45ringsqHb9jdMRGK8EjKtDcwdI_45Kg_1QvWvjRQsX1m_45IzQbogMeta || {},
    component: () => import("/opt/buildhome/repo/pages/engagement-rings/3000-engagement-rings.vue")
  },
  {
    name: "shop-5000-engagement-rings___us",
    path: "/engagement-rings/5000-engagement-rings",
    meta: _5000_45engagement_45ringsnVahKnD0IOoXPnwqocElseYAhn8ehiKr1rjHagXcU3MMeta || {},
    component: () => import("/opt/buildhome/repo/pages/engagement-rings/5000-engagement-rings.vue")
  },
  {
    name: "shop-5000-engagement-rings___uk",
    path: "/uk/engagement-rings/5000-engagement-rings",
    meta: _5000_45engagement_45ringsnVahKnD0IOoXPnwqocElseYAhn8ehiKr1rjHagXcU3MMeta || {},
    component: () => import("/opt/buildhome/repo/pages/engagement-rings/5000-engagement-rings.vue")
  },
  {
    name: "shop-engagement-rings___us",
    path: "/wedding-rings/jewelry-engagement-rings",
    meta: jewelry_45engagement_45ringsmq5g_45isryC6xwF_45eISIb0KO2Quj6ApBWOAXBgc3Yh1QMeta || {},
    component: () => import("/opt/buildhome/repo/pages/wedding-rings/jewelry-engagement-rings.vue")
  },
  {
    name: "shop-engagement-rings___uk",
    path: "/uk/wedding-rings/jewelry-engagement-rings",
    meta: jewelry_45engagement_45ringsmq5g_45isryC6xwF_45eISIb0KO2Quj6ApBWOAXBgc3Yh1QMeta || {},
    component: () => import("/opt/buildhome/repo/pages/wedding-rings/jewelry-engagement-rings.vue")
  },
  {
    name: "engagement-ring-guide-complete-the-ring___us",
    path: "/engagement-ring-guide/complete-the-ring",
    component: () => import("/opt/buildhome/repo/pages/engagement-ring-guide/complete-the-ring.vue")
  },
  {
    name: "engagement-ring-guide-complete-the-ring___uk",
    path: "/uk/engagement-ring-guide/complete-the-ring",
    component: () => import("/opt/buildhome/repo/pages/engagement-ring-guide/complete-the-ring.vue")
  },
  {
    name: "engagement-ring-guide-types-of-diamonds___us",
    path: "/engagement-ring-guide/types-of-diamonds",
    component: () => import("/opt/buildhome/repo/pages/engagement-ring-guide/types-of-diamonds.vue")
  },
  {
    name: "engagement-ring-guide-types-of-diamonds___uk",
    path: "/uk/engagement-ring-guide/types-of-diamonds",
    component: () => import("/opt/buildhome/repo/pages/engagement-ring-guide/types-of-diamonds.vue")
  },
  {
    name: "shop-10000-engagement-rings___us",
    path: "/engagement-rings/10000-engagement-rings",
    meta: _10000_45engagement_45ringsxuvbtCQfdT1nh8Bvd11019ymEvECc6hhVjEYYYHB5t4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/engagement-rings/10000-engagement-rings.vue")
  },
  {
    name: "shop-10000-engagement-rings___uk",
    path: "/uk/engagement-rings/10000-engagement-rings",
    meta: _10000_45engagement_45ringsxuvbtCQfdT1nh8Bvd11019ymEvECc6hhVjEYYYHB5t4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/engagement-rings/10000-engagement-rings.vue")
  },
  {
    name: "customer-service-exchange-buyback-policy___us",
    path: "/customer-service/exchange-buyback-policy",
    meta: exchange_45buyback_45policymJ9Y2RjwofFJBkZ_45fTILzVVq8lVB8RZbSYmw20C6fl8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/customer-service/exchange-buyback-policy.vue")
  },
  {
    name: "customer-service-exchange-buyback-policy___uk",
    path: "/uk/customer-service/exchange-buyback-policy",
    meta: exchange_45buyback_45policymJ9Y2RjwofFJBkZ_45fTILzVVq8lVB8RZbSYmw20C6fl8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/customer-service/exchange-buyback-policy.vue")
  },
  {
    name: "jewelry-instock-engagement-ring-sale___us",
    path: "/jewelry-sale/in-stock-engagement-ring-sale",
    meta: in_45stock_45engagement_45ring_45salebXQUZK6zYSJMNxs6f1e4_459wEVVT_45TGi6ykOOkLaM354Meta || {},
    component: () => import("/opt/buildhome/repo/pages/jewelry-sale/in-stock-engagement-ring-sale.vue")
  },
  {
    name: "jewelry-instock-engagement-ring-sale___uk",
    path: "/uk/jewellery-sale/in-stock-engagement-ring-sale",
    meta: in_45stock_45engagement_45ring_45salebXQUZK6zYSJMNxs6f1e4_459wEVVT_45TGi6ykOOkLaM354Meta || {},
    component: () => import("/opt/buildhome/repo/pages/jewelry-sale/in-stock-engagement-ring-sale.vue")
  },
  {
    name: "engagement-ring-guide-types-of-ring-settings___us",
    path: "/engagement-ring-guide/types-of-ring-settings",
    component: () => import("/opt/buildhome/repo/pages/engagement-ring-guide/types-of-ring-settings.vue")
  },
  {
    name: "engagement-ring-guide-types-of-ring-settings___uk",
    path: "/uk/engagement-ring-guide/types-of-ring-settings",
    component: () => import("/opt/buildhome/repo/pages/engagement-ring-guide/types-of-ring-settings.vue")
  }
]